// extracted by mini-css-extract-plugin
module.exports = {"c-background-zoom":"image-zoom_c-background-zoom__Jqb_5","image-box":"image-zoom_image-box__U95yM","image-main":"image-zoom_image-main__OIogD"};